import { render, staticRenderFns } from "./appStandardResults.vue?vue&type=template&id=4d47975b&scoped=true&"
import script from "./appStandardResults.vue?vue&type=script&lang=js&"
export * from "./appStandardResults.vue?vue&type=script&lang=js&"
import style0 from "./appStandardResults.vue?vue&type=style&index=0&id=4d47975b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d47975b",
  null
  
)

export default component.exports